"use client"
// components/ConfigProvider.tsx
import React, {createContext, useContext, useEffect, useState} from 'react';

interface ConfigData {
  apiUrl: string;
  loginUrl: string;
  docApiUrl: string;
  appName: string;
  pages: [];
  fontSize: {
    default: number;
    label: number;
    gridHeader: number;
    gridPagination: number;
    textBox: number;
    dropdown: number;
    tab: number;
    button: number;
  };
}

const initialConfig: ConfigData = {
  apiUrl: '', // Initial value, will be updated after fetching config
  loginUrl: '',
  docApiUrl: '', // Initial value, will be updated after fetching config
  appName: '',
  pages: [],
  fontSize: {
    default: 12,
    label: 12,
    gridHeader: 12,
    gridPagination: 12,
    textBox: 12,
    dropdown: 12,
    tab: 12,
    button: 14,
  }
};

const ConfigContext = createContext<ConfigData | null>(null);

export const useConfig = (): ConfigData => {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return config;
};

interface ConfigProviderProps {
  children: React.ReactNode;
}

const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  const [config, setConfig] = useState<ConfigData | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const env = process.env.NODE_ENV;
        const response = await fetch(`/config.${env}.json`);
        const configData = await response.json();
        setConfig(configData);
      } catch (error) {
        console.error('Error fetching configuration:', error);
      }
    };

    fetchConfig();
  }, []);

  return (
    <ConfigContext.Provider value={config ?? initialConfig}>
      {children}
    </ConfigContext.Provider>
  );
};

export default ConfigProvider;
